module.exports = __webpack_public_path__ + "static/media/fundo.16e7b0e5.webp";